"use client";
import { jsx as _jsx } from "react/jsx-runtime";
import { RouterProvider } from "../hooks/RouterContext.js";
import { RouteDataProvider } from "../hooks/RouteDataContext.js";
import { HeadProvider } from "../head/HeadContext.js";
import { I18nProvider } from "../i18n/I18nContext.js";
/**
 * Composite provider that wraps the component tree with all
 * framework context providers. The framework injects this
 * automatically — users never need to add providers manually.
 *
 * Provider nesting order (outermost → innermost):
 * 1. RouterProvider — always present
 * 2. HeadProvider — always present
 * 3. I18nProvider — only when i18n is configured
 * 4. RouteDataProvider — only when route data is provided
 */
export function AppProviders({ children, pathname, params, routeData, hasRouteData, headConfig, i18nConfig, locale, }) {
    let tree = children;
    // Innermost: RouteDataProvider (only when data is provided)
    if (hasRouteData) {
        tree = _jsx(RouteDataProvider, { data: routeData, children: tree });
    }
    // I18nProvider (only when configured)
    if (i18nConfig) {
        tree = (_jsx(I18nProvider, { config: i18nConfig, initialLocale: locale, children: tree }));
    }
    // HeadProvider (always)
    tree = _jsx(HeadProvider, { initial: headConfig, children: tree });
    // Outermost: RouterProvider (always)
    tree = (_jsx(RouterProvider, { initialPathname: pathname, initialParams: params, children: tree }));
    return tree;
}
//# sourceMappingURL=AppProviders.client.js.map